import * as React from "react";
import Axios from "axios";
import { navigate } from "gatsby";
import { ProfileContainer } from "./ProfilePageLayoutHelpers";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import ProfileMain from "../ProfileMain/ProfileMain";
import {
  addCRMBasicProfileCDP,
  addReservations,
  clearError,
  isLoggedInSelector,
} from "../../../redux/slices/Member/member";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import { getToken } from "../../../utils/auth0Client";
import useAuthenticate from "../../../hooks/useAuthenticate";
import ErrorMessageAlert from "../../common/ErrorMessageAlert/ErrorMessageAlert";
import { Constants } from "../../../@types/Constants";

const ProfilePageLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = React.useState(true);
  const memberLoggedIn = useAppSelector(isLoggedInSelector);
  const isAuthenticated = useAuthenticate();
  const error = useAppSelector((state) => state.member.error);

  React.useEffect(() => {
    if (!memberLoggedIn) {
      navigate("/login");
    }
  }, [memberLoggedIn, isAuthenticated]);

  React.useEffect(() => {
    let didCancel = false;
    const source = Axios.CancelToken.source();
    (async () => {
      if (isAuthenticated && memberLoggedIn && !didCancel) {
        const tokenId = getToken();
        await dispatch(addCRMBasicProfileCDP(tokenId));
        !didCancel && setIsLoading(false);
      }
    })();
    return () => {
      didCancel = true;
      source.cancel("Request cancelled for fetch profile");
      dispatch(clearError());
    };
  }, [isAuthenticated]);

  return (
    <>
      {isAuthenticated && memberLoggedIn && (
        <ProfileContainer>
          {!error ? (
            isLoading ? (
              <Spinner animation="border" />
            ) : (
              <ProfileMain />
            )
          ) : (
            <ErrorMessageAlert
              errorType={Constants.ERRORSTYPE.TRAVELPASS}
              errorSubType={Constants.ERRORSSUBTYPE.TRAVELPASS.FETCHPROFILE}
              message={`An error occurred while loading your profile`}
            >
              <Alert variant={`danger`} className="text-center">
                {" "}
                An error occurred while loading your profile.
              </Alert>
            </ErrorMessageAlert>
          )}
        </ProfileContainer>
      )}
    </>
  );
};

export default ProfilePageLayout;
